export const formatAddress = (address) => {
  if (address == null || address === "") {
    return "N/A";
  }
  if (typeof address === "string") {
    return address.trim() || "N/A";
  }
  const line1 = [address.address_line_1, address.address_line_2, address.street]
    .filter((p) => p != null && String(p).trim())
    .join(", ");
  const cityStateZip = [address.city, address.state, address.postal_code]
    .filter((p) => p != null && String(p).trim())
    .join(", ");
  const parts = [
    line1 || null,
    cityStateZip || null,
    address.country,
  ].filter((p) => p != null && String(p).trim());
  return parts.length ? parts.join("\n") : "N/A";
};
